import { computed, Injectable, Signal } from '@angular/core';
import { TCalGtmFunnelStepEvent } from '@cal-analytics/gtm';
import { GtmAdapterService } from './gtm-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class GtmAdapterLoanService extends GtmAdapterService {
  private readonly amountRequested$$: Signal<{ amount_requested: number }>;
  private readonly numPayments$$: Signal<{ num_payments: number }>;
  private readonly loanReason$$: Signal<{ loan_reason: string }>;
  private readonly loanAmount$$: Signal<{ loan_amount: number }>;

  constructor() {
    super();
    this.amountRequested$$ = computed(() => ({
      amount_requested: this._amountStore.model$$()?.requestedLoanAmount ?? null
    }));
    this.numPayments$$ = computed(() => ({
      num_payments: this._simulatorStore.model$$()?.numOfPayments ?? null
    }));

    this.loanReason$$ = computed(() => {
      let loanReasonCode = this._purposeStore.model$$()?.loanReasonCode;
      if (loanReasonCode != null) {
        return {
          loan_reason: this._shellStore
            .loanReasons$$()
            .filter((item) => item.value == loanReasonCode)
            .map((item) => item.key)
            .at(0)
        };
      } else {
        return { loan_reason: 'NA' };
      }
    });
    this.loanAmount$$ = computed(() => ({ loan_amount: this._simulatorStore.data$$()?.requestedLoanAmount ?? null }));
  }

  override funnelStepGetter: Signal<Partial<TCalGtmFunnelStepEvent>> = computed(() => ({
    ...this.amountRequested$$(),
    ...this.numPayments$$(),
    ...this.loanReason$$(),
    ...this.loanAmount$$()
  }));

  override funnelEndGetter: Signal<Partial<TCalGtmFunnelStepEvent>> = computed(() => ({
    ...this.amountRequested$$(),
    ...this.numPayments$$(),
    ...this.loanReason$$(),
    ...this.loanAmount$$()
  }));
}
